import { render, staticRenderFns } from "./company.vue?vue&type=template&id=0b799f44&scoped=true"
import script from "./company.vue?vue&type=script&lang=js"
export * from "./company.vue?vue&type=script&lang=js"
import style0 from "./company.vue?vue&type=style&index=0&id=0b799f44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b799f44",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/product/interview/company.vue
// module id = null
// module chunks = 